import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PhoneIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.6667 18.6667H11.6778M7.22222 22H16.1111C16.7005 22 17.2657 21.7659 17.6825 21.3491C18.0992 20.9324 18.3333 20.3671 18.3333 19.7778V4.22222C18.3333 3.63285 18.0992 3.06762 17.6825 2.65087C17.2657 2.23413 16.7005 2 16.1111 2H7.22222C6.63285 2 6.06762 2.23413 5.65087 2.65087C5.23413 3.06762 5 3.63285 5 4.22222V19.7778C5 20.3671 5.23413 20.9324 5.65087 21.3491C6.06762 21.7659 6.63285 22 7.22222 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

PhoneIcon.displayName = 'PhoneIcon';
